import { RecipientExpansionStatus } from 'owa-recipient-common';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { getGroupsAndSmallDLs } from './getGroupsAndSmallDLs';

export function hasRecipientExpansionFailure(recipientInfo: SharingTipRecipientInfo[]): boolean {
    return getGroupsAndSmallDLs(recipientInfo).some(function(smallDL) {
        return (
            smallDL.recipient.expansionStatus === RecipientExpansionStatus.Failed ||
            smallDL.recipient.expansionStatus ===
                RecipientExpansionStatus.SucceededWithDLOrGroupMembers
        );
    });
}
